export const GOOGLE_EXPORT_REQUEST = "GOOGLE_EXPORT_REQUEST";
export const GOOGLE_EXPORT_SUCCESS = "GOOGLE_EXPORT_SUCCESS";
export const GOOGLE_EXPORT_FAIL = "GOOGLE_EXPORT_FAIL";

export const FACEBOOK_EXPORT_REQUEST = "FACEBOOK_EXPORT_REQUEST";
export const FACEBOOK_EXPORT_SUCCESS = "FACEBOOK_EXPORT_SUCCESS";
export const FACEBOOK_EXPORT_FAIL = "FACEBOOK_EXPORT_FAIL";